import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';

function ForStudents() {
  return (
    <Layout>
      <SEO
        keywords={[
          `Студентам`,
          `Профф`,
          `Пыть-Ях`,
          `Профессиональное образование`,
        ]}
        title='Студентам'
      />

      <section className='flex flex-col items-center '>
        <h1 className='text-3xl text-center'>Студентам</h1>
      </section>
    </Layout>
  );
}

export default ForStudents;
